module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch001"
    }
  }, [_c('strong', [_vm._v("Chapter 1")]), _vm._v(" The Ritual: Custom and Chaos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch002",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 2")]), _vm._v(" A Short History of Capital Punishment in England since c.1800")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part One: Hangmen employed in Yorkshire")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch003",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 3")]), _vm._v(" Curry and other York Hangmen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch004",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 4")]), _vm._v(" Bartholomew Binns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch005",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 5")]), _vm._v(" James Berry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch006",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 6")]), _vm._v(" James Billington and Some Curiosities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch007",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 7")]), _vm._v(" Henry Pierrepoint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch008",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 8")]), _vm._v(" Thomas Pierrepoint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch009",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 9")]), _vm._v(" Albert Pierrepoint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch010",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 10")]), _vm._v(" Steve Wade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part two: Obscure Figures and Dark Tales")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch011",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 11")]), _vm._v(" Some Assistants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch012",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 12")]), _vm._v(" Some Tales of Bad Workmanship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Conclusions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/biblo",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Selected Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0